import LoadingAnimation from "../assets/loading-animation.gif";

export const getDesignTokens = (mode) => ({
  palette: {
    mode,
    common: {
      black: "#000000",
      white: "#FFFFFF",
    },
    ...("light" === "light"
      ? {
          text: {
            primary: "#000000",
            secondary: "#666666",
            invert: "#ffffff",
            alpha: {
              95: "rgba(0, 0, 0, 0.95)",
              80: "rgba(0, 0, 0, 0.8)",
              40: "rgba(0, 0, 0, 0.4)",
              15: "rgba(0, 0, 0, 0.15)",
              12: "rgba(0, 0, 0, 0.12)",
              "05": "rgba(0, 0, 0, 0.05)",
              "04": "rgba(0, 0, 0, 0.04)",
              "03": "rgba(0, 0, 0, 0.03)",
              "02": "rgba(0, 0, 0, 0.02)",
            },
          },
          brand: {
            main: "#15ad87",
            dark: "#0e8567",
            light: "#77E4C8",
            background: "#ffffff",
            gradient: "linear-gradient(120deg, #77E4C8 0%, #001f4d 100%)",
            text: "#ffffff",
          },
          grey: {
            300: "#E0E0E0",
            600: "#757575",
          },
          background: {
            default: "#F8FFF6",
            paper: "#FFFFFF",
            dark: "#1E1E1E",
            alpha: {
              40: "rgba(0, 0, 0, 0.4)",
              "05": "rgba(0, 0, 0, 0.05)",
              "04": "rgba(0, 0, 0, 0.04)",
              "02": "rgba(0, 0, 0, 0.02)",
            },
          },
          divider: "rgba(0, 0, 0, 0.12)",
          custom: {
            // Primary colors
            primary: "#15ad87",
            secondary: "#478CCF",
            accent: "#36C2CE",

            // Semantic colors
            success: "#2e7d32",
            error: "#b71c1c",
            warning: "#ffb300",
            info: "#005BB5",

            // Brand colors
            mint: "#77E4C8",
            teal: "#36C2CE",
            blue: "#478CCF",
            purple: "#001f4d",
            oxfordBlue: "#001f4d",

            // Grays
            gray: {
              light: "#f0f2f0",
              medium: "#E0E0E0",
              dark: "#36454F",
            },

            // Shadows
            shadows: {
              xs: "0 2px 8px rgba(0, 0, 0, 0.05)",
              sm: "0 4px 12px rgba(0, 0, 0, 0.08)",
              md: "0 6px 16px rgba(0, 0, 0, 0.1)",
              lg: "0 8px 24px rgba(0, 0, 0, 0.12)",
              xl: "0 12px 32px rgba(0, 0, 0, 0.14)",
            },

            // Gradients
            gradients: {
              primary: "linear-gradient(135deg, #77E4C8 0%, #001f4d 100%)",
              secondary: "linear-gradient(135deg, #36C2CE 0%, #001f4d 100%)",
            },

            // Component specific
            paper: {
              default: "#FFFFFF",
              elevated: "#F8F9FA",
            },
            input: {
              background: "#FFFFFF",
              border: "#E0E0E0",
              hoverBorder: "#B0B0B0",
              focusBorder: "#15ad87",
              text: "#000000",
              placeholder: "#666666",
            },

            loading: {
              animation: LoadingAnimation,
            },
          },
          components: {
            MuiOutlinedInput: {
              styleOverrides: {
                root: {
                  backgroundColor: "#FFFFFF",
                  "& fieldset": {
                    borderColor: "#E0E0E0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#B0B0B0",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#15ad87",
                  },
                },
              },
            },
            MuiButton: {
              styleOverrides: {
                root: {
                  textTransform: "none",
                },
                containedBrand: {
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#0e8567",
                  },
                },
              },
            },
            MuiDivider: {
              styleOverrides: {
                root: {
                  borderColor: "rgba(0, 0, 0, 0.12)",
                },
              },
            },
          },
        }
      : {
          text: {
            primary: "#ffffff",
            secondary: "#b0b0b0",
            invert: "#000000",
            alpha: {
              95: "rgba(255, 255, 255, 0.95)",
              80: "rgba(255, 255, 255, 0.8)",
              40: "rgba(255, 255, 255, 0.4)",
              15: "rgba(255, 255, 255, 0.15)",
              12: "rgba(255, 255, 255, 0.12)",
              10: "rgba(255, 255, 255, 0.1)",
              "05": "rgba(255, 255, 255, 0.05)",
              "04": "rgba(255, 255, 255, 0.04)",
              "03": "rgba(255, 255, 255, 0.03)",
              "02": "rgba(255, 255, 255, 0.02)",
            },
          },
          brand: {
            main: "#15ad87",
            dark: "#0e8567",
            light: "#8FF8DB",
            background: "#121212",
            gradient: "linear-gradient(120deg, #77E4C8 0%, #001f4d 100%)",
            text: "#ffffff",
          },
          grey: {
            300: "#404040",
            600: "#9e9e9e",
          },
          background: {
            default: "#121212",
            paper: "#1E1E1E",
            dark: "#000000",
            alpha: {
              40: "rgba(255, 255, 255, 0.4)",
              "05": "rgba(255, 255, 255, 0.05)",
              "04": "rgba(255, 255, 255, 0.04)",
              "02": "rgba(255, 255, 255, 0.02)",
            },
            elevation: {
              1: "#242424",
              2: "#282828",
              3: "#2c2c2c",
              4: "#323232",
              6: "#383838",
              8: "#3e3e3e",
              12: "#444444",
              16: "#4a4a4a",
              24: "#505050",
            },
          },
          divider: "rgba(255, 255, 255, 0.12)",
          custom: {
            // Primary colors
            primary: "#77E4C8",
            secondary: "#5B9EE1",
            accent: "#4DD8E4",

            // Semantic colors
            success: "#2ecc71",
            error: "#e74c3c",
            warning: "#f1c40f",
            info: "#3498db",

            // Brand colors
            mint: "#8FF8DB",
            teal: "#4DD8E4",
            blue: "#5B9EE1",
            purple: "#001f4d",
            oxfordBlue: "#001f4d",

            // Grays
            gray: {
              light: "#303030",
              medium: "#404040",
              dark: "#2C3E50",
            },

            // Shadows
            shadows: {
              xs: "0 2px 8px rgba(0, 0, 0, 0.15)",
              sm: "0 4px 12px rgba(0, 0, 0, 0.3)",
              md: "0 6px 16px rgba(0, 0, 0, 0.4)",
              lg: "0 8px 24px rgba(0, 0, 0, 0.5)",
              xl: "0 12px 32px rgba(0, 0, 0, 0.6)",
            },

            // Gradients
            gradients: {
              primary: "linear-gradient(135deg, #8FF8DB 0%, #001f4d 100%)",
              secondary: "linear-gradient(135deg, #4DD8E4 0%, #001f4d 100%)",
            },

            // Component specific
            paper: {
              default: "#1E1E1E",
              elevated: "#242424",
            },
            input: {
              background: "#242424",
              border: "#404040",
              hoverBorder: "#505050",
              focusBorder: "#77E4C8",
              text: "#ffffff",
              placeholder: "#b0b0b0",
            },

            loading: {
              animation: LoadingAnimation,
            },
          },
          components: {
            MuiOutlinedInput: {
              styleOverrides: {
                root: {
                  backgroundColor: "#242424",
                  "& fieldset": {
                    borderColor: "#404040",
                  },
                  "&:hover fieldset": {
                    borderColor: "#505050",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#77E4C8",
                  },
                  "& input": {
                    color: "#ffffff",
                  },
                  "& input::placeholder": {
                    color: "#b0b0b0",
                    opacity: 1,
                  },
                },
              },
            },
            MuiButton: {
              styleOverrides: {
                root: {
                  textTransform: "none",
                },
                containedBrand: {
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#8FF8DB",
                  },
                },
                text: {
                  color: "#77E4C8",
                  "&:hover": {
                    backgroundColor: "rgba(119, 228, 200, 0.08)",
                  },
                },
              },
            },
            MuiDivider: {
              styleOverrides: {
                root: {
                  borderColor: "rgba(255, 255, 255, 0.12)",
                },
              },
            },
            MuiPaper: {
              styleOverrides: {
                root: {
                  backgroundImage: "none",
                  backgroundColor: "#1E1E1E",
                  '&[elevation="1"]': {
                    backgroundColor: "#242424",
                  },
                  '&[elevation="2"]': {
                    backgroundColor: "#282828",
                  },
                  '&[elevation="3"]': {
                    backgroundColor: "#2c2c2c",
                  },
                },
              },
            },
          },
        }),
    typography: {
      fontFamily:
        '"Kanit", "Inter", "Roboto", "Helvetica", "Arial", sans-serif',
      textTransform: "none",
    },
  },
});
